module.exports = __webpack_public_path__ + "img/ics_o_cod_amount.5a2f7079.svg";